"use client"

import { useState, useEffect } from "react"

const SUPPORTED_LOCALES = ["nl", "en", "es"] as const

declare global {
  interface Window {
    ictportal_user_reviews?: {
      locale?: string
      logged_in?: boolean
    }
    ictportal_user_experiences?: {
      locale?: string
    }
  }
}

function resolveLocale(): string {
  if (typeof window === "undefined") {
    return "nl"
  }

  // PHP wp_localize_script first; legacy/dev key as fallback
  const candidates = [
    window.ictportal_user_reviews?.locale,
    window.ictportal_user_experiences?.locale,
  ]

  for (const candidate of candidates) {
    if (candidate && SUPPORTED_LOCALES.includes(candidate as (typeof SUPPORTED_LOCALES)[number])) {
      return candidate
    }
  }

  return "nl"
}

export function useLocale(): string {
  const [locale, setLocale] = useState<string>(() => resolveLocale())

  useEffect(() => {
    setLocale(resolveLocale())

    const handleStorageChange = () => {
      setLocale(resolveLocale())
    }

    window.addEventListener("storage", handleStorageChange)
    return () => window.removeEventListener("storage", handleStorageChange)
  }, [])

  return locale
}
